import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { getCurrentUser } from 'aws-amplify/auth';
import awsconfig from './aws-exports';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Login from './components/Login';
import FileExplorer from './components/FileExplorer';
import KanbanBoard from './components/KanbanBoard';
import Calendar from './components/Calendar';
import Playlists from './components/Playlists';
import Lyrics from './components/Lyrics';
import Videos from './components/Videos';
import './styles/global.css';

// Configure Amplify
console.log('Configuring Amplify with:', awsconfig);
Amplify.configure(awsconfig);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkUser();
  }, []);

  async function checkUser() {
    try {
      const currentUser = await getCurrentUser();
      console.log('Current user:', currentUser);
      setUser(currentUser);
    } catch (error) {
      console.log('No authenticated user found:', error);
      setUser(null);
    }
    setLoading(false);
  }

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <div className="app">
        <Header user={user} setUser={setUser} />
        <main>
          <Routes>
            <Route path="/" element={<Home user={user} />} />
            <Route path="/login" element={user ? <Navigate to="/files" /> : <Login setUser={setUser} />} />
            <Route path="/files" element={user ? <FileExplorer /> : <Navigate to="/login" />} />
            <Route path="/tasks" element={user ? <KanbanBoard /> : <Navigate to="/login" />} />
            <Route path="/calendar" element={user ? <Calendar /> : <Navigate to="/login" />} />
            <Route path="/playlists" element={user ? <Playlists /> : <Navigate to="/login" />} />
            <Route path="/lyrics" element={user ? <Lyrics /> : <Navigate to="/login" />} />
            <Route path="/videos" element={user ? <Videos /> : <Navigate to="/login" />} />
            {/* Add a catch-all route to redirect to home */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
